import React from "react";
const FooterAddress = () => {
  return (
    <div>
      <div id="RegisterUnsecuredLoan" className="sapo-modal register-modal"></div>
      <div id="RegisterUnsecuredLoanSuccess" className="sapo-modal register-modal register-success-modal"></div>
      <div id="RegisterPay" className="sapo-modal register-modal"></div>
      <div id="RegisterPaySuccess" className="sapo-modal register-modal register-success-modal"></div>
      <div id="RegisterFinance" className="sapo-modal register-modal"></div>
      <div id="RegisterFinanceSuccess" className="sapo-modal register-modal register-success-modal"></div>
      <div id="RegisterEbook" className="sapo-modal register-modal"></div>
      <div id="RegisterEbookSuccess" className="sapo-modal register-modal register-success-modal"></div>
      <div id="RegisterExpress" className="sapo-modal register-modal"></div>
      <div id="RegisterExpressSuccess" className="sapo-modal register-modal register-success-modal"></div>
      <div id="RegisterEnter" className="sapo-modal register-modal"></div>
      <div id="RegisterEnterSuccess" className="sapo-modal register-modal register-success-modal"></div>
      <div id="RegisterInvoice" className="sapo-modal register-modal"></div>
      <div id="RegisterInvoiceSuccess" className="sapo-modal register-modal register-success-modal"></div>
      <div id="RegisterDigitalSignature" className="sapo-modal register-modal"></div>
      <div id="RegisterDigitalSignatureSuccess" className="sapo-modal register-modal register-success-modal"></div>
    </div>
  );
};

export default FooterAddress;
